export const OPEN_DID_YOU_MEAN_MODAL = 'OPEN_DID_YOU_MEAN_MODAL';
export const CLOSE_DID_YOU_MEAN_MODAL = 'CLOSE_DID_YOU_MEAN_MODAL';
export const UPDATE_FIELD_FROM_DID_YOU_MEAN = 'UPDATE_FIELD_FROM_DID_YOU_MEAN';

function openDidYouMeanModal(values, renderedfieldName, modalId) {
  return {
    type: OPEN_DID_YOU_MEAN_MODAL,
    isDidYouMeanModalShown: true,
    filteredValues: values,
    renderedfieldName,
    modalId
  };
}

function closeDidYouMeanModal() {
  return {
    type: CLOSE_DID_YOU_MEAN_MODAL,
    isDidYouMeanModalShown: false,
    renderedfieldName: 'NONE',
    modalId: 'NONE'
  };
}

function updateFromDidYouMean(stateFieldName, stateFieldValue) {
  return {
    type: UPDATE_FIELD_FROM_DID_YOU_MEAN,
    isDidYouMeanModalShown: false,
    renderedfieldName: 'NONE',
    modalId: 'NONE',
    stateFieldName,
    stateFieldValue
  };
}

export function showDidYouMeanModal(values, renderedfieldName, modalId) {
  return (dispatch) => {
    dispatch(openDidYouMeanModal(values, renderedfieldName, modalId));
  };
}

export function hideDidYouMeanModal() {
  return (dispatch) => {
    dispatch(closeDidYouMeanModal());
  };
}

export function selectFromDidYouMeanModal(stateFieldName, stateFieldValue) {
  return (dispatch) => {
    dispatch(updateFromDidYouMean(stateFieldName, stateFieldValue));
  };
}
